import Entry from "./entry";
// import bibliography from "./bibliography";
import bibliography2 from "./bibliography2";
import miniMap from './miniMap';

export default class Entries {
   constructor(pages) {
      console.log('Constructing Entries');
      $('.loading--state').text('Creating entries');
      var _this = this;
      this.entries = [];
      this.themes = [];
      this.cats = [];
      this.legitEntries = [];
      window.bibsCount = 0;
      window.preventClick = false;
      window.entries = this;

      for(let i = 0; i < pages.length; i++) {
         var headers = pages[i].headers;

         pages[i].rows.forEach(row => {
            _this.entries.push(new Entry(row, headers));

            // if last
            if(i==pages.length-1) {
            }
         });
      }

      window.isDragging = false;
      window.hasDragged = false;

      $(document).on('mouseup', function(e) {
         if(window.hasDragged) {
            $(window.isDragging).removeClass('no-hover').css({
               userSelect : 'auto'
            });
            setTimeout(() => {
               window.preventClick = false;
            }, 10);
         }
         window.isDragging = false;
      }).on('mousemove', function(e) {
         if (window.isDragging) {
            // console.log(window.isDragging);
            window.preventClick = true;
            const newLeft = e.pageX - window.mouseMoveOffset.x;
            const newTop = e.pageY - window.mouseMoveOffset.y;
            $(window.isDragging).css({
               left: newLeft + 'px',
               top: newTop + 'px',
               userSelect : 'none'
            });
            
            $(window.isDragging).addClass('no-hover');
            window.mouseovers.forEach(e => {
               clearTimeout(e);
            });
            window.mouseovers = [];
            window.hasDragged = true;
         }
      });

      _this.entries.forEach((a, idx) => {
         if(a.theme && _this.themes.indexOf(a.theme) < 0) {
            _this.themes.push(a.theme);
         }

         if(a._cat && _this.cats.indexOf(a._cat) < 0) {
            _this.cats.push(a._cat);
         }

         a.id = idx;
         a.createBlock(idx);
      });

      console.log('createBlocks done', _this.entries.length);

      _this.entries.forEach((a, idx) => {
         a.initRelateds();
         // for(var i=0; i<_this.entries.length; i++) {
         //    _this.entries[i].createBlock();
         // }

         if(idx==_this.entries.length-1) {
            setTimeout(function(){
               console.log('initRelateds done', _this.entries.length);
               $('body').addClass('rdy');
               $('.loading').fadeOut(400);

               setTimeout(function(){
                  $('body').addClass('instant');
                  if($('.box#hyperimage').length>=0){
                     let initialFocus = $('.box#hyperimage').get(0);
                     setTimeout(function(){
                        window.entries.legitEntries[0].centerBox(initialFocus);
                        setTimeout(function(){
                           $('body').removeClass('instant');
                           
                           setTimeout(function(){
                              $('body.blur').removeClass('blur');
                              window.miniMap = new miniMap();
                              $(window).trigger('resize');
                           }, 100);
                        }, 200);
                     }, 10);
                  } else {
                     $('body.blur').removeClass('blur');
                     window.miniMap = new miniMap();
                     $(window).trigger('resize');
                  }
               }, 50);

               setTimeout(function(){ 
                  // window.bib = new bibliography();
                  let bib = window.entries.legitEntries.filter(a => { return a.sources.length>0 });

                  window.bib = new bibliography2(bib);
               }, 500);
            }, 1000);
         }
      });
   }
}